var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "4" } },
            [_c("v-card-title", [_vm._v("Места")])],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-radio-group",
            {
              attrs: {
                value: _vm.fields.seating.enabled,
                disabled: _vm.loading || _vm.isOnlyEdit,
              },
            },
            [
              _c("v-radio", {
                attrs: { label: "Без мест", value: false },
                on: {
                  click: function ($event) {
                    return _vm.toggleSeatingType(false)
                  },
                },
              }),
              _c("v-radio", {
                attrs: { label: "Вручную", value: true },
                on: {
                  click: function ($event) {
                    return _vm.toggleSeatingType(true)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.fields.seating.enabled
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("span", [_vm._v("Название *")]),
                  _c("v-text-field", {
                    attrs: {
                      outlined: "",
                      disabled: _vm.loading || _vm.isOnlyEdit,
                    },
                    model: {
                      value: _vm.fields.seating.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.fields.seating, "name", $$v)
                      },
                      expression: "fields.seating.name",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-row",
        [
          _vm.fields.seating.enabled && _vm.fields.seating.zones.length
            ? _vm._l(
                _vm.fields.seating.zones,
                function (seatZone, seatZoneIndex) {
                  return _c(
                    "v-card",
                    {
                      key: seatZoneIndex,
                      staticClass: "mb-5",
                      attrs: { width: "100%", outlined: "" },
                    },
                    [
                      _c(
                        "v-container",
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "11" } },
                                [
                                  _c("v-card-title", [
                                    _vm._v(
                                      'Зона "' + _vm._s(seatZone.title) + '"'
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass:
                                    "d-flex justify-center align-center",
                                  attrs: { cols: "1" },
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        icon: "",
                                        disabled: _vm.loading || _vm.isOnlyEdit,
                                        loading: _vm.loading,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteSeatZone(
                                            seatZone.id,
                                            seatZoneIndex
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "red" } },
                                        [_vm._v("mdi-trash-can-outline")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("span", [_vm._v("Название")]),
                                  _c("v-text-field", {
                                    attrs: {
                                      outlined: "",
                                      disabled: _vm.loading || _vm.isOnlyEdit,
                                    },
                                    model: {
                                      value: seatZone.title,
                                      callback: function ($$v) {
                                        _vm.$set(seatZone, "title", $$v)
                                      },
                                      expression: "seatZone.title",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.fields.seating.enabled &&
                          _vm.fields.seating.zones.length
                            ? _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12" } },
                                    [
                                      _c("PlaceZoneBuilder", {
                                        attrs: {
                                          "is-loading": _vm.loading,
                                          "is-only-edit": _vm.isOnlyEdit,
                                          "seat-rows-list": seatZone.rows,
                                        },
                                        on: {
                                          "duplicate-seat-row": function (
                                            $event
                                          ) {
                                            return _vm.duplicateSeatRow(
                                              $event,
                                              seatZoneIndex
                                            )
                                          },
                                          "remove-seat-row": function ($event) {
                                            return _vm.deleteSeatRow(
                                              $event,
                                              seatZoneIndex
                                            )
                                          },
                                          "create-seat-row": function ($event) {
                                            return _vm.createSeatRows(
                                              $event,
                                              seatZoneIndex
                                            )
                                          },
                                          "remove-seat": function ($event) {
                                            return _vm.deleteSeat(
                                              $event,
                                              seatZoneIndex
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }
              )
            : _vm._e(),
        ],
        2
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _vm.fields.seating.enabled
                ? _c(
                    "v-btn",
                    {
                      staticClass: "mt-10",
                      attrs: {
                        disabled: _vm.loading || _vm.isOnlyEdit,
                        loading: _vm.loading,
                      },
                      on: { click: _vm.createSeatZone },
                    },
                    [_vm._v("Добавить зону")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }